'use client';
import Loader from '../Loader/Loader.js';

var COMPONENT_ID = "IconButton";
var defaultProps = {
    radius: 56,
    size: "xxs1",
    type: "button",
    as: "button",
    transitionDuration: 200,
    contentGap: 8,
    color: "primary",
    variant: "default",
    loader: Loader
};

export { COMPONENT_ID, defaultProps };
